import { esDoubleBedroomsPalettes } from "../../../../Posts/05-tematicas/04-dormitorios-matrimoniales-modernos/doubleBedroomsPalettes.js";
import { localizeTematicPalettes } from "../../../../src/helpers/localizeTematicPalettes.js";
import * as React from 'react';
export default {
  esDoubleBedroomsPalettes,
  localizeTematicPalettes,
  React
};